<template>
  <div class="goods-list-box">
    <OperationBoxComponent :actions="actions" :filters="filters" :disabled="params.ids.length === 0" />
    <GoodsListComponent :page-data="pageData" @onSelectChanged="onSelectChanged" @goodsListChanged="updateGoodsList" />
  </div>
</template>

<script>
import OperationBoxComponent from '../../../components/common/OperationBoxComponent'
import GoodsListComponent from '../../../components/goods/GoodsListComponent'
import {GoodsRequestUtil} from '../../../utils/GoodsRequestUtil'

export default {
  name: 'GoodsTrashPage',
  components: {
    GoodsListComponent,
    OperationBoxComponent
  },
  mounted () {
    this.updateGoodsList()
  },
  data () {
    return {
      actions: [
        { title: '通过', type: 'button', theme: 'success', action: this.pass },
        { title: '删除', type: 'button', theme: 'danger', action: this.delete }
      ],
      filters: [{searchValue: '', type: 'title', options: [{title: '标题', value: 'title'}], action: this.onFilterChange}],
      pageData: {},
      params: {
        ids: []
      },
      queryParam: {
        type: null,
        keywords: null
      }
    }
  },
  methods: {
    updateGoodsList () {
      let that = this
      GoodsRequestUtil.queryGoodsTrash({queryParam: this.queryParam}, function (response) {
        if (response.items) {
          that.pageData = response
        }
      })
    },
    onFilterChange (item) {
      this.queryParam.type = item.type
      this.queryParam.keywords = item.searchValue
      this.updateGoodsList()
    },
    pass () {
      GoodsRequestUtil.pass(this.params, this.updateGoodsList)
    },
    delete () {
      GoodsRequestUtil.delete(this.params, this.updateGoodsList)
    },
    onSelectChanged (ids) {
      this.params.ids = ids
    }
  }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/whaledge/goods/GoodsTrashPage.vue